export const rootStyles = {
  position: 'absolute',
  bottom: '100%',
  left: 0,
  marginBottom: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  padding: '6px 12px',
  maxWidth: '100%',
  boxShadow: ({ palette }) => palette.shadow.m,
  backgroundColor: 'background.paper',
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'divider',
  zIndex: 10,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const labelStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
};

export const hintGroupStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  flexShrink: 0,
  color: 'text.secondary',
};

export const hintKeyStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 18,
  height: 18,
  padding: '0 4px',
  borderRadius: 0.5,
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper',
  color: 'text.secondary',
  // Intentionally below the smallest CDS scale step: keyboard-key glyphs inside an 18px kbd chrome —
  // 12px text overflows the bordered key cap (mirrors TeamChatEntitySuggestions' hint keys).
  fontSize: 11,
  lineHeight: 1,
};
